module.exports = __webpack_public_path__ + "media/guinea-pig.85bcd95d.mp3";